import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';

/**
 * Routing für das Notfall-Modul (One-Pager § 2).
 *
 *   /notfall                    → Express-Wizard (Kategorie-Wahl, public)
 *   /notfall/buchung/:id        → Live-Status-Seite (auth-pflichtig)
 *   /notfall/:slug              → Detail-Seite (PLZ + Verfügbarkeit, public)
 *   /notfall/:slug/buchen       → Buchungsformular (auth-pflichtig)
 *
 * Reihenfolge wichtig: <c>buchung/:id</c> muss VOR der generischen
 * <c>:slug</c>-Route stehen, sonst greift dort der Detail-Loader. Express-Auth
 * via Magic-Link kommt in einer eigenen Iteration — Etappe 3 nutzt den
 * bestehenden authGuard, der Anonymous-User zu <c>/login?redirect=…</c> schickt.
 */
export const notfallRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./wizard/notfall-wizard.component').then(
        (m) => m.NotfallWizardComponent,
      ),
  },
  {
    path: 'buchung/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./status/notfall-status.component').then(
        (m) => m.NotfallStatusComponent,
      ),
  },
  {
    path: ':slug',
    loadComponent: () =>
      import('./detail/notfall-detail.component').then(
        (m) => m.NotfallDetailComponent,
      ),
  },
  {
    path: ':slug/buchen',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./buchen/notfall-buchen.component').then(
        (m) => m.NotfallBuchenComponent,
      ),
  },
];
